import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import DashboardLayout from "../components/DashboardLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function NewAnalysis() {
  const { t, lang } = useI18n();
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  const [facts, setFacts] = useState("");
  const [tags, setTags] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/matters", {
        title,
        facts,
        tags: tags.split(",").map((s) => s.trim()).filter(Boolean),
      });
      toast.success(t("common.success"));
      nav(`/matters/${res.data.id}`);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail && typeof detail === "object" && detail.error === "matter_limit_reached") {
        toast.error(detail.message, { action: { label: lang === "el" ? "Αναβάθμιση" : "Upgrade", onClick: () => nav("/pricing") } });
      } else {
        toast.error((detail && (detail.message || detail)) || t("common.error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-3xl">
        <div className="kicker">Dikigoros.io</div>
        <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl text-slate-900">{t("matter.createTitle")}</h1>
        <p className="mt-2 text-slate-600 text-sm">
          {lang === "el"
            ? "Δημιουργήστε μια νέα υπόθεση και συνεχίστε με την ανάλυση."
            : "Create a new matter and continue with the analysis."}
        </p>

        <form onSubmit={submit} className="mt-10 card-premium p-8 space-y-6">
          <div>
            <label className="kicker !text-slate-500 block mb-2">{t("matter.title")}</label>
            <input
              required value={title} onChange={(e) => setTitle(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none"
              data-testid="new-matter-title"
              placeholder={lang === "el" ? "π.χ. Καταγγελία σύμβασης εργασίας" : "e.g. Employment contract termination"}
            />
          </div>
          <div>
            <label className="kicker !text-slate-500 block mb-2">{t("matter.facts")}</label>
            <textarea
              rows={8} value={facts} onChange={(e) => setFacts(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none"
              data-testid="new-matter-facts"
              placeholder={lang === "el" ? "Περιγράψτε σύντομα τα γεγονότα…" : "Briefly describe the facts…"}
            />
          </div>
          <div>
            <label className="kicker !text-slate-500 block mb-2">{t("matter.tags")}</label>
            <input
              value={tags} onChange={(e) => setTags(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none"
              data-testid="new-matter-tags"
              placeholder="employment, dismissal, cyprus"
            />
          </div>
          <button disabled={loading} className="btn-primary rounded-full px-6 py-3 font-semibold" data-testid="new-matter-submit">
            {loading ? t("common.loading") : t("matter.save")}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
}
